import React from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
import { Check, X } from 'lucide-react';
const forWho = ['Personas de 40+ años que sienten rigidez en las manos o pies al despertar.', 'Hispanos en USA que sufren de pesadez abdominal después de cada comida.', 'Profesionales con altos niveles de estrés que no tienen tiempo para dietas complicadas.', 'Quienes buscan una solución rápida y natural para verse mejor antes de un evento.'];
const notForWho = ['Atletas de alto rendimiento que buscan planes de entrenamiento.', 'Personas que buscan una "pastilla mágica" sin cambiar ni un solo hábito.', 'Menores de 25 años con metabolismos que aún no enfrentan cambios hormonales.'];
export function WhoThisIsFor() {
  return <SectionWrapper className="bg-white" data-id="element-142">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-143">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-144">
          {/* Para quién es */}
          <div className="bg-green-50/50 rounded-3xl p-8 md:p-10 border border-green-100" data-id="element-145">
            <h3 className="text-2xl font-bold text-gray-900 mb-8 flex items-center gap-3" data-id="element-146">
              <span className="bg-green-100 text-green-600 p-2 rounded-lg" data-id="element-147">
                <Check className="w-6 h-6" data-id="element-148" />
              </span>
              Este programa ES para ti si:
            </h3>
            <ul className="space-y-6" data-id="element-149">
              {forWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-150">
                  <Check className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-151" />
                  <span className="text-gray-700 text-lg" data-id="element-152">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Para quién NO es */}
          <div className="bg-red-50/50 rounded-3xl p-8 md:p-10 border border-red-100" data-id="element-153">
            <h3 className="text-2xl font-bold text-gray-900 mb-8 flex items-center gap-3" data-id="element-154">
              <span className="bg-red-100 text-red-600 p-2 rounded-lg" data-id="element-155">
                <X className="w-6 h-6" data-id="element-156" />
              </span>
              Este programa NO es para ti si:
            </h3>
            <ul className="space-y-6" data-id="element-157">
              {notForWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-158">
                  <X className="w-6 h-6 text-red-400 flex-shrink-0 mt-0.5" data-id="element-159" />
                  <span className="text-gray-600 text-lg" data-id="element-160">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}